/**
 * Hook for managing Admin Hub recent items
 * Re-exports functionality from AdminHubContext for convenience
 */
import { useAdminHub, type RecentItem } from '../components/admin-hub/context/AdminHubContext';

interface UseAdminHubRecentsReturn {
  recentItems: RecentItem[];
  addRecentItem: (item: Omit<RecentItem, 'timestamp'>) => void;
  clearRecents: () => void;
}

/**
 * Hook for managing Admin Hub recent items
 * Provides convenient access to recents state and actions
 */
export const useAdminHubRecents = (): UseAdminHubRecentsReturn => {
  const { recentItems, addRecentItem, clearRecents } = useAdminHub();

  return {
    recentItems,
    addRecentItem,
    clearRecents,
  };
};

export default useAdminHubRecents;
